import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { AccessResult } from "utils/access";

import { showDeleteConfirmation } from "./DeleteConfirmation";

type StackSettingsIntegrationsWebhooksDropdownProps = {
  onEditClick: () => void;
  onDetailsClick: () => void;
  canUpdateStack: AccessResult;
  endpoint: string;
  id: string;
  refetchQueriesOnDelete?: string[];
  stackId: string;
};

const StackSettingsIntegrationsWebhooksDropdown = ({
  onEditClick,
  refetchQueriesOnDelete,
  endpoint,
  id,
  stackId,
  onDetailsClick,
  canUpdateStack,
}: StackSettingsIntegrationsWebhooksDropdownProps) => {
  const handleDeleteClick = () => {
    showDeleteConfirmation({ endpoint, id, refetchQueriesOnDelete, stackId });
  };

  return (
    <DropdownMenuEllipsis tooltip="Webhook actions">
      <DropdownMenuItem onAction={onDetailsClick}>Details</DropdownMenuItem>
      {(canUpdateStack.result || !!canUpdateStack.message) && (
        <DropdownMenuItem
          onAction={onEditClick}
          isDisabled={!canUpdateStack.result}
          tooltip={canUpdateStack.message}
        >
          Edit
        </DropdownMenuItem>
      )}
      {(canUpdateStack.result || !!canUpdateStack.message) && (
        <DropdownMenuItem
          onAction={handleDeleteClick}
          danger
          isDisabled={!canUpdateStack.result}
          tooltip={canUpdateStack.message}
        >
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default StackSettingsIntegrationsWebhooksDropdown;
